import Tooltip from '../ui-components/Tooltip'
import Icon from '../../preact-components/assets'
import KeyInsightCardContent from '@insided/deprecated-control/analytics/KeyInsightCardContent'

interface KeyInsightCardProps {
  title: string
  titleTooltip?: string
  comparisionTooltip?: string
  total?: number | string
  showComparisionUnavailable?: boolean
  percent?: number
  hideComparisionWithPreviousPeriod?: boolean
  isPercentage?: boolean
  isLoading: boolean
  isKeyInsightAvailable?: boolean
  keyInsightUnavailableMessage?: string
}

// eslint-disable-next-line import/prefer-default-export
export const KeyInsightCard = ({
  title,
  titleTooltip,
  percent,
  showComparisionUnavailable = false,
  comparisionTooltip,
  isLoading,
  hideComparisionWithPreviousPeriod = false,
  isKeyInsightAvailable = true,
  keyInsightUnavailableMessage,
  isPercentage = false,
  total = 0
}: KeyInsightCardProps) => {
  return (
    <div className='metric-summary-wrapper'>
      <div className='metric-summary'>
        <div className='metric-header'>
          <div className='metric-title'>{title}
            {titleTooltip && (
              <Tooltip
                position='left'
                trigger={<Icon icon='question' size={16} customClass='icon-info' />}
                customClasses='metric-help-tooltip'
                tooltipMessage={titleTooltip}
              />
            )}
          </div>
        </div>
        <KeyInsightCardContent
          percent={percent}
          showComparisonUnavailable={showComparisionUnavailable}
          comparisonTooltip={comparisionTooltip}
          isLoading={isLoading}
          hideComparisonWithPreviousPeriod={hideComparisionWithPreviousPeriod}
          isKeyInsightAvailable={isKeyInsightAvailable}
          keyInsightUnavailableMessage={keyInsightUnavailableMessage}
          isPercentage={isPercentage}
          total={total}
        />
      </div>
    </div>
  )
}
